import $ from 'jquery';
import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';
import PerfectScrollbar from 'perfect-scrollbar';
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'


$.ajaxSetup({
  headers: {
    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  }
});

export function display_error(msg)
{	if(msg) $('.merror p').html(msg);
	$(".merror").click(function() {
			$(".merror, .merror p").stop().fadeOut(500,function() {
			});
		});
	$(".merror, .merror p").stop(true,true);	
	$(".merror").css('height', 'auto');
	$(".merror p").show();
	var barh = $(".merror").height();
	$(".merror p").hide();
	$(".merror").delay(200).show().animate({height: barh},500, function() {
		$(".merror p, .message_img").fadeIn(500);
		$(".merror p, .message_img").delay(10000).fadeOut(500, function() {
				$(".merror").slideUp(1500,function() {
					//$(".merror").css({height: 'auto'});
				});
				
		});
	});	
};

export function display_notice(msg)
{	if(msg) $('.flash_success > p').html(msg);
	$(".flash_success ").hover(function() {
		$(".flash_success").stop().fadeOut(600);
	});
	$(".flash_success, .flash_success p").stop(true,true);	
	$(".flash_success").css('height', 'auto');
	$(".flash_success p").show();
	var barh = $(".flash_success").height();
	$(".flash_success p").hide();
	$(".flash_success").delay(200).show().animate({height: barh},500, function() {
		$(".flash_success p").fadeIn(500);
		$(".flash_success p").delay(3000).fadeOut(1000, function() {
				$(".flash_success").slideUp(1500,function() {	
				});
		});
	});	
}

$(document).on("turbolinks:load",function(){

	//disable all buttons insdie form on submit
	$("button.disabler").closest('form').on('submit', function(e) {
        $(this).find("button.disabler").css({"font-weight": "bold","text-decoration": "underline"});
        $('form.'+$(this).attr('class')).find("button.disabler").prop("disabled", true);
    });
	//messaggi di errore
	$(".flash_success p").each(function() {
		var val;
		if(!((val = $(this).html()) === "")) 
		{	display_notice($(this).html());
		}
	});
	$(".merror p").each(function() {
		var val;
		if(!((val = $(this).html()) === "")) 
		{	display_error($(this).html());
		}
	});

	if(Cookies.get('user_menus') == undefined)	Cookies.set("user_menus",JSON.stringify({}));

	//Attivazione help
	$('.help_activator').click(function(event) {
		event.preventDefault();
		var msg = $('#help_message').html();
		$.notifyClose();
		$.notify(msg, 	{ 	allow_dismiss: true, 
							type: 'warning',
							delay: 10000,
							position: 'fixed'
						});
	});
	

	$('.datepicker').datepicker(
	 		{	language: 'it'
  	}).attr('readonly','readonly');

$('.clr_datepicker').datepicker(
      { language: 'it',
      clearBtn: true
    }).attr('readonly','readonly');
	//file input problem
	$('.custom-file-input').on('change',function(){
    	var filename = this.files[0].name;
    	$(this).next('label.custom-file-label').text(filename);
	});

	//perfect scrollbars to who wants it
	if($('.perfect-scrollbar').length > 0) {
		new PerfectScrollbar('.perfect-scrollbar',{
			swipeEasing: false
		});
	}
	//user menu
    $('#sidebarCollapse').on('click', function () {
        $('#sidebar, #content').toggleClass('active');
        $('.collapse.in').toggleClass('in');
        $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });
    $("#sidebar ul li.voice").on("show.bs.collapse", function(){
    	var menus = JSON.parse(Cookies.get("user_menus"));
    	menus[$(this).data('voice')] = true;
    	Cookies.set("user_menus",JSON.stringify(menus));
  	});
  	$("#sidebar ul li.voice").on("hide.bs.collapse", function(){
    	var menus = JSON.parse(Cookies.get("user_menus"));
    	menus[$(this).data('voice')] = false;
    	Cookies.set("user_menus",JSON.stringify(menus));
  	});


  	// Make select beautiful
	$('select.select2').select2({
		allowClear: true,
    minimumInputLength: 2,
    multiple: true,
	});

	// Replace ▼ and ▲ in sort_link with nicer icons
	$(".sort_link").each(function(){
		// Remove the &nbsp; in the text
		var sort_link_text = $(this).text().replace('\xA0', '');

		if(sort_link_text.indexOf("▼") >= 0){
			$(this).text(sort_link_text.replace("▼",""));
			$(this).prepend('<span class="fa fa-arrow-circle-down"></span>');
		}
		else if(sort_link_text.indexOf("▲") >= 0){
			$(this).text(sort_link_text.replace("▲",""));
			$(this).prepend('<span class="fa fa-arrow-circle-up"></span>');
			}
	});

	//FILTRO RICERCHE
  	$('.js-show-index-filters').click(function(){
	    //$(".filter-well").slideToggle();
	    $("#search-form").slideToggle();
	    
	    $(this).parents(".filter-wrap").toggleClass("collapsed");    
	    //$("#expanded_searching").val( $("#expanded_searching").val() == 'true' ? 'false' : 'true');
	    $("span.fa", $(this)).toggleClass("fa-angle-right");
	    $("span.fa", $(this)).toggleClass("fa-angle-down");
  	});

	// submit auto,matico nella ricerca veloce
	$(".js-quick-search").click(function(){
    	$(this).select();
	});
	$(".js-quick-search").val($(".js-quick-search-target").val());
	// Catch the quick search form submit and submit the real form
	$("#quick-search").submit(function(){
		$(".js-quick-search-target").val($(".js-quick-search").val());
		$("#search-form form").submit();
		return false;
	});
	$(".js-submit-filter").click(function(){
		$(".js-quick-search-target").val($(".js-quick-search").val());
		$("#search-form form").submit();
		return false;
	});
	//cancella ricerca
	$(".js-trash-filter").click(function(){
		$(".js-quick-search-target").val(null);
		console.log($(this).closest('form'));
		$('form.search_fields').find('input:not([type=hidden]):not([type=submit]),select').val(null);
		$("#submit_searching").remove();
		$("#search-form form").submit();
		return false;
	});

	//DELETE ACTION LINK
  $('body').on('click', '.delete-resource', function() {
    var el = $(this);
    if (confirm(el.data("confirm"))) {
      $.ajax({
        type: 'POST',
        url: $(this).prop("href"),
        data: {
          _method: 'delete',
        },
        dataType: 'script',
        success: function(response) {
          el.parents("tr").fadeOut('hide', function() {
              $(this).remove();
          });
        },
        error: function(response, textStatus, errorThrown) {
          //show_flash('error', response.responseText);
          display_error(response.responseText);
        }
      });
    }
    return false;
  });

});



